/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipologia funzionale di un TipoPratica
 */
export enum TipologiaPratica {

    BUONI_LIBRO = 'BUONI_LIBRO',

    BUONI_SPESA = 'BUONI_SPESA',

    AGEVOLAZIONE = 'AGEVOLAZIONE',

    PACCO_ALIMENTARE = 'PACCO_ALIMENTARE',

    CEDOLE_LIBRARIE = 'CEDOLE_LIBRARIE',

    MENSA = 'MENSA'
}

